export function readFileAsync(file: File | Blob, reader: FileReader): Promise<string> {
    return new Promise((resolve, reject) => {
      
      reader.onload = (e: any) => {
        if (e.target.readyState !== FileReader.DONE) {
          return;
        }
        resolve(reader.result as string);
      };
  
      reader.onerror = reject;
  
      reader.readAsDataURL(file);
    })
  }